import axios from '@/helpers/axios';

export function signIn({ email, password }) {
  return axios
    .post('/dealer/account/sign-in', {
      email,
      password,
    })
    .then(({ data }) => {
      return {
        ...data.dealer,
        permissions: data.permissions,
      };
    });
}

export function restorePassword({ email }) {
  return axios.post('/account/password/forgot', {
    email,
  });
}

export function resetPassword({ token, password }) {
  return axios.post('/account/password/reset', {
    recoveryToken: token,
    password,
  });
}

export function getAccount() {
  return axios.post('/dealer/account/get', {}).then(({ data }) => {
    return data.dealer;
  });
}

export function updateAccount(dealer) {
  if (!dealer.user.password) {
    delete dealer.user.password;
  }

  return axios
    .post('/dealer/account/update', {
      dealer,
    })
    .then(({ data }) => {
      return data.dealer;
    });
}
